import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import HomePage from "./pages/home";
import AboutUs from "./pages/aboutUs";
import Services from "./pages/services";
import ContactUs from "./pages/contactUs";
import Training from "./pages/training";
import GRC from "./pages/servicesInfo/grc";
import CybersecurityMaturityAssessment from "./pages/servicesInfo/cyberSecurityAssesment";
import DataPrivacy from "./pages/servicesInfo/dataPrivacy";
import CybersecurityForAI from "./pages/servicesInfo/forAI";
import CybersecurityForStartups from "./pages/servicesInfo/forStartups";
import PenetrationTesting from "./pages/servicesInfo/penetrationTesting";
import LevelPage from "./pages/LevelPage";

const HashScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        const sectionId = hash.replace('#', '');
        const element = document.getElementById(sectionId);
        if (element) {
          setTimeout(() => {
            const navbarHeight = 120;
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - navbarHeight;
            window.scrollTo({ top: offsetPosition, behavior: "smooth" });
          }, 100);
        }
      }
    };
    handleHashScroll();
  }, [location]);

  return null;
};

const LayoutWrapper = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="bg-black text-white">
      <Router>
        <HashScrollHandler />
        <LayoutWrapper>
          <Routes>
            <Route path="/" element={<Training />} />
            <Route path="/training" element={<Navigate to="/" replace />} />
            <Route path="/training/:slug" element={<LevelPage />} />
            <Route
              path="/services"
              element={
                <div className="pt-24">
                  <section id="home">
                    <HomePage />
                  </section>
                  <section id="about">
                    <AboutUs />
                  </section>
                  <section id="services">
                    <Services />
                  </section>
                  <section id="contact">
                    <ContactUs />
                  </section>
                </div>
              }
            />
            <Route path="/services/grc" element={<GRC />} />
            <Route
              path="/services/cybersecurity-maturity-assessment"
              element={<CybersecurityMaturityAssessment />}
            />
            <Route path="/services/data-privacy" element={<DataPrivacy />} />
            <Route
              path="/services/cybersecurity-for-ai"
              element={<CybersecurityForAI />}
            />
            <Route
              path="/services/cybersecurity-for-startups"
              element={<CybersecurityForStartups />}
            />
            <Route
              path="/services/penetration-testing"
              element={<PenetrationTesting />}
            />
          </Routes>
        </LayoutWrapper>
      </Router>
    </div>
  );
}

export default App;
